export default {
  'de-AT': {
    common: require('./de-AT/translation.json'),
  },
  'de-DE': {
    common: require('./de-DE/translation.json'),
  },
  'en-AR': {
    common: require('./en-AR/translation.json'),
  },
  'en-CA': {
    common: require('./en-CA/translation.json'),
  },
  'en-GB': {
    common: require('./en-GB/translation.json'),
  },
  'en-IE': {
    common: require('./en-IE/translation.json'),
  },
  'en-NL': {
    common: require('./en-NL/translation.json'),
  },
  'en-US': {
    common: require('./en-US/translation.json'),
  },
  'es-AR': {
    common: require('./es-AR/translation.json'),
  },
  'fr-CA': {
    common: require('./fr-CA/translation.json'),
  },
  'nl-NL': {
    common: require('./nl-NL/translation.json'),
  },
};
